export enum LogSourceType {
  PAGE,
  COMPONENT,
  SERVICE,
  HELPER,
  WEBKIT
}
